import React from "react";

const Light = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    viewBox="0 0 80 80"
  >
    <g fill="none" fillRule="evenodd">
      <g stroke="#FFF" strokeWidth="1.8">
        <g>
          <g>
            <path
              strokeLinecap="round"
              d="M39 0L39 8"
              transform="translate(-98 -53) translate(98 53) translate(2 2)"
            />
            <g strokeLinecap="round" stroke-linejoin="round">
              <path
                d="M4 25L4 33"
                transform="translate(-98 -53) translate(98 53) translate(2 2) translate(0 10) rotate(90 4 29)"
              />
              <path
                d="M12.293 0.293L12.293 8.293"
                transform="translate(-98 -53) translate(98 53) translate(2 2) translate(0 10) rotate(-45 12.293 4.293)"
              />
              <path
                d="M12.293 47.707L12.293 55.707"
                transform="translate(-98 -53) translate(98 53) translate(2 2) translate(0 10) scale(1 -1) rotate(-45 -112.54 0)"
              />
            </g>
            <path
              strokeLinecap="round"
              stroke-linejoin="round"
              d="M72 35L72 43"
              transform="translate(-98 -53) translate(98 53) translate(2 2) matrix(0 1 1 0 33 -33)"
            />
            <path
              strokeLinecap="round"
              stroke-linejoin="round"
              d="M63.707 10.293L63.707 18.293"
              transform="translate(-98 -53) translate(98 53) translate(2 2) scale(-1 1) rotate(-45 0 168.095)"
            />
            <path
              strokeLinecap="round"
              stroke-linejoin="round"
              d="M63.707 57.707L63.707 65.707"
              transform="translate(-98 -53) translate(98 53) translate(2 2) rotate(135 63.707 61.707)"
            />
            <path
              d="M52.346 20.847c-4.863-4.063-11.265-5.68-17.56-4.438-8.477 1.674-15.284 8.929-16.555 17.644-1.037 7.112 1.455 14.215 6.666 19 2.347 2.157 3.764 5.263 3.989 8.747.004.063.016.124.03.184V72.91c0 .601.48 1.09 1.074 1.09h18.013c.594 0 1.075-.489 1.075-1.09v-11.1-.007c0-3.241 1.452-6.372 4.09-8.815C57.51 48.965 60 43.243 60 37.29c0-6.385-2.789-12.378-7.654-16.443zM28.185 66.854L49.848 66.854"
              transform="translate(-98 -53) translate(98 53) translate(2 2)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Light;
